import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import { withStyles } from "@material-ui/core/styles";
import { ArrowRight } from "./Icons";
import { SmallText } from "../styleguide";
import buildAssetUrl from "../utils/buildAssetUrl";
import PodcastsContent from "./PodcastsContent";
import withGeneralTranslations from "../hocs/withGeneralTranslations";
import { compose } from "recompose";
import AudiotrackIcon from "@material-ui/icons/Audiotrack";
import VideocamIcon from "@material-ui/icons/Videocam";
import placeholderImage from "../assets/images/podcast-placeholder.jpg";

const styles = () => ({
    containerStyle: {
        position: "relative",
        paddingLeft: 16,
        display: "flex",
        borderBottom: "1px solid #f0f1f2",
        borderRight: "1px solid #f0f1f2",
        "&:first-child": {
            borderTop: "1px solid #f0f1f2",
        },
    },
    itemUnreadStyle: {
        "&:before": {
            position: "absolute",
            top: 0,
            left: 0,
            right: "5px",
            bottom: 0,
            background: "#E40045",
            width: "6px",
            content: '""',
            display: "block",
            borderBottom: "1px solid #fff",
        },
    },
    contentStyle: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        paddingBottom: "4px",
        width: "100%",
    },
    cardMediaWrapperStyle: {
        minWidth: 102,
        width: 102,
        height: 102,
        margin: "20px 0",
    },
    cardContentStyle: {
        padding: "20px 16px 10px 16px",
        position: "relative",
    },
    cardActionStyle: {
        padding: "0 16px 4px 16px",
    },
    icon: {
        position: "absolute",
        top: 16,
        right: 16,
        color: "#838a92",
    },
});

const LinkItem = ({ linkUrl, linkLabel, classes: { linkItemStyle, arrowStyle, linkStyle } }) => (
    <div className={linkItemStyle}>
        <ArrowRight className={arrowStyle} size={12} />
        <Link to={linkUrl} className={linkStyle}>
            <SmallText>{linkLabel}</SmallText>
        </Link>
    </div>
);

const StyledLinkItem = withStyles(() => ({
    linkItemStyle: {
        display: "inline-flex",
        alignItems: "center",
        marginRight: 8,
        cursor: "pointer",
    },
    arrowStyle: {
        color: "#e40045",
    },
    linkStyle: {
        marginLeft: 2,
        textDecoration: "none",
    },
}))(LinkItem);

export const getImageComponent = image => {
  if (image) {
    const { type, url } = buildAssetUrl(image, 102)
    if (type === 'image') {
      return (
        <CardMedia
          image={url}
          style={{
            width: 102,
            minWidth: 102,
            height: 102,
            borderRadius: 10
          }}
        />
      )
    }
  }

    return (
        <CardMedia
            image={placeholderImage}
            style={{
                width: 102,
                minWidth: 102,
                height: 102,
                borderRadius: 10,
            }}
        />
    );
};

const PodcastsItem = ({
    title,
    date,
    description,
    linkUrl,
    teaserImage,
    type,
    classes: { containerStyle, contentStyle, cardMediaWrapperStyle, cardContentStyle, cardActionStyle, icon },
    generalTranslations,
}) => {
    const image = getImageComponent(teaserImage);

    return (
        <Card elevation={0} square className={containerStyle}>
            <div className={cardMediaWrapperStyle}>{image}</div>
            <div className={contentStyle}>
                <CardContent classes={{ root: cardContentStyle }}>
                    <PodcastsContent title={title} description={description} date={date} />
                    {type === "audio" && <AudiotrackIcon title="Audio" size={12} className={icon} />}
                    {type === "video" && <VideocamIcon title="Video" size={12} className={icon} />}
                </CardContent>
                <CardActions className={cardActionStyle}>
                    <StyledLinkItem linkLabel={generalTranslations("to-podcast")} linkUrl={linkUrl} />
                </CardActions>
            </div>
        </Card>
    );
};

PodcastsItem.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    linkUrl: PropTypes.string,
    teaserImage: PropTypes.string,
    type: PropTypes.string,
};

export default compose(withGeneralTranslations, withStyles(styles))(PodcastsItem);



// WEBPACK FOOTER //
// ./src/components/PodcastsItem.js